export const SHARE_DIALOG_BREAKPOINTS = [
    {
        query: "(max-width: 860px), (max-height: 620px)",
        paperMargin: 16,
        titlePadding: "16px 20px 14px 20px",
        iconFontSize: 28,
        iconVerticalAlign: "-7px",
        iconMarginRight: 8,
        dialogContentPaddingBottom: 10,
        dialogActionsPadding: "8px 20px 16px 20px",
        panelBorderRadius: 4,
    },
    {
        query: "(max-width: 640px), (max-height: 520px)",
        paperMargin: 8,
        titlePadding: "12px 14px 10px 14px",
        iconFontSize: 24,
        iconVerticalAlign: "-5px",
        iconMarginRight: 6,
        dialogContentPaddingBottom: 8,
        dialogActionsPadding: "8px 14px 12px 14px",
        panelBorderRadius: 3,
    }
];

export function buildShareDialogContainerResponsiveCss() {
    return SHARE_DIALOG_BREAKPOINTS.map(({
        query,
        paperMargin,
        titlePadding,
        iconFontSize,
        iconVerticalAlign,
        iconMarginRight,
        dialogContentPaddingBottom,
        dialogActionsPadding,
    }) => `
        @media ${query} {
            .MuiDialog-paper {
                margin: ${paperMargin}px;
                width: calc(100% - ${paperMargin * 2}px);
                max-width: none;
            }

            .MuiDialogTitle-root {
                padding: ${titlePadding};
            }

            .MuiDialogTitle-root .MuiIcon-root {
                font-size: ${iconFontSize}px;
                vertical-align: ${iconVerticalAlign};
                margin-right: ${iconMarginRight}px;
            }

            .dialog-content {
                padding-bottom: ${dialogContentPaddingBottom}px;
            }

            .MuiDialogActions-root {
                padding: ${dialogActionsPadding};
                flex-wrap: wrap;
                row-gap: 8px;
            }
        }
    `).join("\n");
}

export function buildShareDialogPanelResponsiveCss() {
    return SHARE_DIALOG_BREAKPOINTS.map(({ query, panelBorderRadius }) => `
        @media ${query} {
            max-width: 100%;
            border-radius: ${panelBorderRadius}px;
        }
    `).join("\n");
}

export function buildShareDialogCollaborateResponsiveCss() {
    return SHARE_DIALOG_BREAKPOINTS.map(({ query }) => `
        @media ${query} {
            .share-dialog-collaborate-content .invite-input .tags-input {
                min-height: 72px;
            }

            .share-dialog-collaborate-content .invite-input .MuiChip-root {
                height: 34px !important;
                margin: 2px !important;
            }

            .share-dialog-collaborate-content .invite-input input {
                height: 30px;
                font-size: 13px;
                padding: 4px;
            }

            .share-dialog-collaborate-textarea {
                min-height: 56px;
            }

            .share-dialog-collaborate-textarea textarea {
                padding: 4px 8px;
                font-size: 13px;
            }
        }
    `).join("\n");
}
